import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { emailHistoryReportFilterParamsSchema } from '~bank-reports/types/EmailHistoryReport'

import { emailHistoryReportQueryOptions } from '../../service/emailHistoryReportQueryOptions'

export const emailHistoryReportRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: 'email-history',
    validateSearch: (search: Record<string, unknown>) => emailHistoryReportFilterParamsSchema.parse(search),
    loaderDeps: ({ search }) => search,
    loader: ({ cause, deps, context }) => {
      if (cause === 'stay') {
        return null
      }
      return (context as BPRoutingContext).queryClient.ensureQueryData(emailHistoryReportQueryOptions(deps))
    },
    component: lazyRouteComponent(() => import('./EmailHistoryReport'))
  })
